<template>
  <div
    class="calling-representative">
    <div class="col-left">
    <RepresentativePhoto
      :class="{ traitor: mep.traitor }"
      class="calling-representative-photo"
      :photoUrl="mep.portrait"
      :friendly="mep.friendly"
      :alt="mep.name" />
    </div>
    <div class="col-right">
      <div class="calling-representative-info">
        <p v-if="callInitiated" class="calling-representative-intro">{{ $t('pages.thanks.title-2') }}</p>
        <p v-if="!mep.friendly && !mep.traitor && !callInitiated" class="calling-representative-intro">{{ $t('components.representative.not-pledged') }}</p>
        <p v-if="mep.friendly && !mep.traitor && !callInitiated" class="calling-representative-intro">{{ $t('components.representative.already-pledged') }}</p>
        <p v-if="mep.traitor && !callInitiated" class="calling-representative-intro">{{ $t('components.representative.traitor') }}</p>
        <h2 class="calling-representative-name">{{ mep.name }}</h2>
        <p class="calling-representative-small">{{ mep.national_party }}</p>
      </div>
      <div
        v-if="onFrontpage"
        class="please-call">
        <svg class="call-arrow" version="1.1" viewBox="0 0 180 40">
          <g transform="translate(0,-286.41665)">
            <g transform="translate(-275.64084,263.36525)">
              <path
                 d="m 428.46404,29.235963 10.22197,10.221988 H 275.64084 v 8.067381 h 163.04517 l -10.22197,10.221987 h 13.23398 L 455.9537,43.491642 441.69802,29.235963 Z"
                 style="stroke-width:0;stroke-miterlimit:10;stroke-dasharray:none" />
            </g>
          </g>
        </svg>
      </div>
      <!-- <a v-on:click="toggleInfo">This is how it works <span v-if="!moreInfo">▾</span><span v-if="moreInfo">▴</span></a> -->
      <div v-if="!mep.friendly && onFrontpage " class="get-prepared">
        <span>{{ $t('components.representative.not-ready') }} </span>
        <router-link class="fat-underline" :to="{ name: 'thanks', params: { callInitiated: false } }">{{ $t('components.representative.get-prepared') }}</router-link>
      </div>
      <button class="call-button" v-if="callButtonIsShown" v-on:click="callButtonFunction">
        {{ $t('components.phoneinput.call-now') }}
      </button>
      <div class="dots" v-if="callInitiated">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
import RepresentativePhoto from '@/components/SectionCalling/RepresentativePhoto.vue'
import PhoneInput from '@/components/SectionCalling/PhoneInput.vue'
import CountriesMixin from '@/mixins/CountriesMixin.vue'

export default {
  name: 'Representative',
  components: {
    RepresentativePhoto,
    PhoneInput,
  },
  props: {
    mep: Object,
    onFrontpage: Boolean,
    callInitiated: Boolean,
    callButtonIsShown: Boolean,
    callButtonFunction: Function,
  },
  mixins: [CountriesMixin],
  data () {
    return {
      moreInfo: false,
    }
  },
  computed: {
    countries () {
      return this.$root.countries.map((c) => c[0])
    },
    mepFirstname () {
      return this.mep.name.split(' ')[0];
    }
  },
  methods: {
    toggleInfo () {
      this.moreInfo = !this.moreInfo
    }
  },
}
</script>

<style lang=scss scoped>
@import '@/assets/styles/_variable.scss';

@media screen and (max-width: 900px) {
  .please-call {
    display: none;
  }
}

@media screen and (max-width: 600px) {
  .calling-representative-text {
    margin-left: 0 !important;
  }
}

.calling-representative {
  display: flex;
  max-width: 900px;
  align-items: flex-start;
  @media (max-width: 1000px) {
    flex-direction: column;
  }
  @media (max-width: 900px) {
    flex-direction: row;
  }
  @media (max-width: 479px) {
    flex-direction: column;
  }


  margin: 0 auto;

  .calling-representative-photo {
    align-self: flex-start;
    margin: 0 1em .5em 0;

  }
  /* traitor */
  .traitor {
    position: relative;
  }
  .traitor::after, .traitor::before {
    position: absolute;
    content: '';
    background: red;
    display: block;
    width: 100%;
    height: 30px;
    transform: rotate(-45deg);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 1;
  }
  .traitor::after {
    transform: rotate(45deg) !important;
  }

  .calling-representative-explainer {
    margin-bottom: 0;
  }

  .col-right {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    .calling-representative-info {
      margin: 0;

      .calling-representative-intro {
        margin: 0;
        line-height: 1.2em;
        margin-bottom: .3em;
      }

      .calling-representative-name {
        margin: 0 0 .1em;
        font-size: 2em;
        line-height: .9em;
      }

      .calling-representative-small {
        display: block;
        font-size: 0.8em;
        line-height: 1em;
        margin: 0.1em 0;
      }
    }
    .please-call {
      display: flex;
      @media (max-width: 900px) {
        display: none;
      }
      flex-direction: column;
      .call-arrow {
        fill: rgba(0,0,0,.2);
        margin: -8% -8% 0 0;
        width: 108%;
        align-self: flex-end;
      }
    }
    .call-button {
      padding: 0.4em 0.8em;
      margin: 0.5em 0 0;
      align-self: flex-end;
      box-shadow: 10px 10px rgba(0, 0, 0, 0.2);
    }
  }

  .more-info {
    width: 100%;
    background-color: $dark-text-color;
    color: $main-bg;
    margin-top: 1em;
    padding: 1em;

    h2 {
      color: $main-bg;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
